/* eslint-disable no-console */
import uploadImageAndFetchLink from '../../../../../../common/uploadImage';
import getImageAspectRatio from '../../../../../../common/getImageAspectRatio';
import eventService from '../../../../../../common/eventService';
import * as columnItemActions from '../../../../../../actions/columnItem';
import { ERR_IMAGE_UPLOAD_UPLOAD } from '../../../../../../constants/Errors';

export const updateContentWithSrc = async (dispatch, selectedElementData, src, imageSuffix) => {
    try {
        const { blockIndex, columnIdx, elmIdx, content, contentValues } = selectedElementData;
        const newContentValues = { ...contentValues, src, aspectRatio: await getImageAspectRatio(src) };
        const newContent = { ...content, ...newContentValues, mimetype: `image/${imageSuffix}` };
        dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
    } catch (error) {
        console.error(error);
        eventService.notify(error.customMessage ? error.customMessage : ERR_IMAGE_UPLOAD_UPLOAD, true);
    }
};

export const uploadImageToBackend = async (imageData, selectedElementData, imageSuffix, dispatch, hasURL) => {
    try {
        let uploadedImageSrc;
        if (hasURL) {
            uploadedImageSrc = await uploadImageAndFetchLink({ imageUrl: imageData, imageSuffix }, hasURL);
        } else {
            uploadedImageSrc = await uploadImageAndFetchLink({ imageData }, hasURL);
        }
        updateContentWithSrc(dispatch, selectedElementData, uploadedImageSrc, imageSuffix);
    } catch (err) {
        console.error(err);
        eventService.notify(err, true);
    }
};
